module.exports = __webpack_public_path__ + "images/home/product/mobile/third-party-3aef1fb321bea0ccc9e942ee5eaba43e.png";